import type { MailboxInfo } from "owa-client-types";
import type { ComposeViewState } from "owa-mail-compose-store";
import { action } from "satcheljs";

export type ComposeFromMenuTask = {
    task: "WaitForActiveSaving";
    viewState: ComposeViewState;
} | {
    task: "InsertSignature";
    viewState: ComposeViewState;
} | {
    task: "SaveAfterMailboxChange";
    viewState: ComposeViewState;
} | {
    task: "CreateAndOpenCompose";
    mailboxInfo: MailboxInfo;
    oldComposeViewState: ComposeViewState;
    initializeCompose: (viewState: ComposeViewState) => void;
};

export interface ComposeFromMenuTaskActionMessage {
    task: ComposeFromMenuTask;
    onComplete: () => void;
    onError: (error: unknown) => void;
}

export const composeFromMenuTaskAction: (task: ComposeFromMenuTask, onComplete: () => void, onError: (error: unknown) => void) => ComposeFromMenuTaskActionMessage = action("COMPOSE_FROM_MENU_TASK", (task: ComposeFromMenuTask, onComplete: () => void, onError: (error: unknown) => void): ComposeFromMenuTaskActionMessage => ({
    task,
    onComplete,
    onError,
}));
